export let DEFAULT_SAMPLES = 20;
export const setDefaultSamples = (n) => (DEFAULT_SAMPLES = n);
